import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export const BillingSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [polling, setPolling] = useState(true);

  useEffect(() => {
    // Stripe webhook will handle the DB sync. Just show confirmation and let user proceed.
    const t = setTimeout(() => setPolling(false), 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          {polling ? (
            <Loader2 className="w-16 h-16 text-emerald-500 mx-auto mb-4 animate-spin" />
          ) : (
            <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
          )}
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Payment successful!</h1>
          <p className="text-slate-600 mb-6">
            Your subscription is now active. You'll receive a receipt by email shortly.
          </p>
          {sessionId && <p className="text-xs text-slate-400 font-mono mb-4 break-all">Session: {sessionId}</p>}
          <Link to="/dashboard">
            <Button className="w-full" data-testid="billing-success-continue">Continue to Dashboard</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export const BillingCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Checkout cancelled</h1>
          <p className="text-slate-600 mb-6">
            No charge was made. You can try again anytime.
          </p>
          <Button onClick={() => navigate(-1)} data-testid="billing-cancel-back">Go Back</Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingSuccess;
